<div class="overlay-spinner" *ngIf="isLoading | async">
    <mat-spinner></mat-spinner>
</div>